/*
 * Copyright (c) 2014-2023 Comparatio
 */

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment, fiveDecCompanies } from './environments/environment';

if (environment.production || environment.development || environment.test) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule);



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/main.ts